import React, { useEffect } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Inicio from "./ui/pages/Landing/Inicio";
import InicioPassengers from "./ui/pages/Passengers/InicioPassengers";
import InicioDrivers from "./ui/pages/Drivers/InicioDrivers";
import InicioFAQ from "./ui/pages/FAQ/InicioFAQ";
import InicioTerms from "./ui/pages/Terms/InicioTerms";
import * as ROUTES from "../src/constants/routes";
import "./App.css";

// Google analytics
// import GoogleAnalytics from "./google-analytics";
import ReactGA from 'react-ga';
const TRACKING_ID = "G-CKD4M31ZLK"

ReactGA.initialize(TRACKING_ID);

function App() {

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        {/* Google analytics */}
        {/* <GoogleAnalytics /> */}
        <Route exact path={ROUTES.HOME} component={Inicio} />
        <Route exac path={ROUTES.PASSENGERS} component={InicioPassengers} />
        <Route exac path={ROUTES.DRIVERS} component={InicioDrivers} />
        {/* <Route exac path={ROUTES.SECURITY} component={InicioSecurity} /> */}
        <Route exac path={ROUTES.QUESTIONS} component={InicioFAQ} />
        <Route exac path={ROUTES.TERMS} component={InicioTerms} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
